module.exports = __webpack_public_path__ + "img/Home_Inquiry_Logo.3ce486f3.png";